import { Box, FormLabel, Link, Tooltip, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface AppFieldViewProps {
	label?: string;
	labelElement?: React.ReactNode;
	valueElement?: React.ReactNode;
	value?: string;
	subValue?: string;
	editButton?: React.ReactNode;
	link?: string;
}

export default function AppFieldView({
	label,
	labelElement,
	valueElement,
	value,
	subValue,
	link,
	editButton,
}: AppFieldViewProps) {
	return (
		<>
			<AppFormLabel>
				{label}
				{labelElement && labelElement}
			</AppFormLabel>
			<Box display='flex' alignItems='center'>
				<Typography variant='body1' sx={{ wordBreak: 'break-word' }}>
					{valueElement ? (
						<>{valueElement}</>
					) : link ? (
						value == undefined || value == '' ? (
							'-'
						) : (
							<Link href={link} target='_blank' color='inherit'>
								{value}
							</Link>
						)
					) : (
						<>{value == undefined || value == '' ? '-' : value}</>
					)}
					{subValue && (
						<Typography
							variant='body2'
							color='common.neutral50'
							display='inline-block'
						>
							{subValue}
						</Typography>
					)}
				</Typography>

				{editButton && <>{editButton}</>}
			</Box>
		</>
	);
}

export function AppFormLabel({ children }: { children: ReactNode }) {
	return <FormLabel sx={{ fontSize: '12px' }}>{children}</FormLabel>;
}
